import Api from "../../api";

import dateFormat from "dateformat";
import { ResidueType, Appointment, Dashboard } from "./models.jsx";
import {Event} from "../shifter/models";

const residuesUrl = "residue-types";
const appointmentsUrl = "appointments";
const dashboardUrl = "dashboard";

class ResidueTypeApi extends Api {

	get(callback) {
	    var url = this.baseUrl + residuesUrl
	    this.client.get(url).then((response) => {
	    	
	    	var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new ResidueType(response.data[index]));
			}

	    	callback({ 
	    		result: data,
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });

	}

	create(residueType, callback) {
	    var url = this.baseUrl + residuesUrl
	    this.client.post(url,residueType).then((response) => {
	    	callback({ 
	    		result: new ResidueType(response.data),
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	update(residueType, callback) {
	    var url = this.baseUrl + residuesUrl + "/" + residueType.id;
	    this.client.put(url,residueType).then((response) => {
	    	callback({ 
	    		result: new ResidueType(response.data),
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });

	}

}

class AppointmentApi extends Api {

	search(date, callback) {
	    var url = this.baseUrl + appointmentsUrl

	    this.client.get(url, { 
	    	params: { date: dateFormat(date, "isoDate") }
	    }).then((response) => {
	    		var rangeHeader = response.headers["range"];
			var total = parseInt(rangeHeader.split("/")[1]);

			var data = [];
			for (var index = 0; index < response.data.length; index++) {
				data.push(new Appointment(response.data[index]));
			}

	    	callback({ 
	    		result: { data: data, total: total }, 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

	create(appointment, callback) {
		const url = this.baseUrl + appointmentsUrl;

		this.client.post(url, appointment).then((response) => {
			callback({
				result: new Appointment(response.data),
				error: null
			});
		}).catch((error) => {
			callback({
				result: null,
				error: this.extractError(error)
			});
		});
	}

}

class DashboardApi extends Api {

	get(date, callback) {
	    var url = this.baseUrl + dashboardUrl

	    this.client.get(url, { 
	    	params: { date: dateFormat(date, "isoDate") }
	    }).then((response) => {
	    	callback({ 
	    		result: new Dashboard(response.data), 
	    		error: null
	    	});
	    }).catch((error) => {
	    	callback({ 
	    		result: null, 
	    		error: this.extractError(error)
	    	});
	    });
	}

}


class ResiduesServiceApi{

	constructor(baseUrl) {
		this.residueTypes = new ResidueTypeApi(baseUrl);
		this.appointments = new AppointmentApi(baseUrl);
		this.dashboard = new DashboardApi(baseUrl);
	}

}

export default ResiduesServiceApi;